import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    width: '100%',
    minWidth: 0,
    overflow: 'hidden',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      flexWrap: 'nowrap',
    },
  },
  alignRight: {
    justifyContent: 'flex-end',
  },
  alignLeft: {
    justifyContent: 'flex-start',
  },
  alignCenter: {
    justifyContent: 'center',
  },
  padding: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  button: {
    maxHeight: '40px',
    minWidth: theme.spacing(12),
    flexShrink: 0,
    padding: theme.spacing(1),
    borderRadius: '4px',
    fontSize: theme.typography.pxToRem(14),
    letterSpacing: theme.typography.pxToRem(1),
    [theme.breakpoints.down('md')]: {
      flex: '1 1 0',
      minWidth: 0,
      width: 'auto',
    },
  },
}));
